import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router-dom';
import { injectIntl, defineMessages } from 'react-intl';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import { required } from '../../../../../utils/ValidationUtil';
import { dropDownNormalizer } from '../../../../../utils/NomalizeUtil';
import { renderAsyncSelector } from '../../../../../components/selector/AsyncSelector';
import { searchRespondents } from '../../../../../services/apps/RespondentServices';
import { dispatchGraphqlErrors } from '../../../../../utils/NotificationUtil';
import { NameAndEmail } from '../../../../../components/input/DropDown';
import { getRespondentsFromCS } from '../../../../../utils/JobProfileUtil';

const i18n = defineMessages({
  csSearchPlaceHolder: { id: 'choose.candidate', defaultMessage: 'Choose candidate' },
  add: { id: 'actions.add', defaultMessage: 'Add' },
  cancel: { id: 'actions.cancel', defaultMessage: 'Cancel' },
});

const parseNameAndEmail = (first = '', last = '', email = '') => `${first} ${last} (${email})`;

class HintsCSAddForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      respondentList: [],
      loadingRespondents: false,
    };

    this.searchRespondent = this.searchRespondent.bind(this);
  }

  componentDidMount() {
    this.fetchRespondents();
  }

  searchRespondent(query) {
    this.fetchRespondents(query);
  }

  async fetchRespondents(query) {
    const { match, onActionFailed } = this.props;
    this.setState({ loadingRespondents: true });
    try {
      const { aid } = match.params;
      const data = await searchRespondents({
        aid,
        query,
      });

      this.setState({
        respondentList: data,
        loadingRespondents: false,
      });
    } catch (err) {
      onActionFailed(err);
      this.setState({ loadingRespondents: false });
    }
  }

  render() {
    const {
      concurrentStudies, onAdd, onCancel, intl,
    } = this.props;
    const {
      handleSubmit, pristine, invalid, submitting,
    } = this.props;
    const { formatMessage } = intl;
    const { respondentList, loadingRespondents } = this.state;
    const respondentsCS = getRespondentsFromCS(concurrentStudies);

    return (
      <form className="form" onSubmit={handleSubmit(onAdd)}>
        <div className="p-grid">
          <div className="p-col-12">
            <div className="form-group">
              <Field
                name="respondentId"
                component={renderAsyncSelector}
                data={respondentList}
                processing={loadingRespondents}
                filter="contains"
                normalize={data => dropDownNormalizer(data, 'id')}
                onSearch={this.searchRespondent}
                valueField="id"
                textField={item => (item ? parseNameAndEmail(item.firstName, item.lastName, item.email) : '')}
                placeholder={`- ${formatMessage(i18n.csSearchPlaceHolder)} -`}
                valueComponent={NameAndEmail}
                validate={[required]}
                selectedList={respondentsCS}
              />
            </div>
          </div>
          <div className="p-col-12">
            <div className="form-group text-center">
              <Button
                type="submit"
                icon={submitting ? 'pi pi-spin pi-spinner' : ''}
                label={formatMessage(i18n.add)}
                disabled={pristine || submitting || invalid}
              />
              <Button
                className="p-button-secondary"
                label={formatMessage(i18n.cancel)}
                onClick={onCancel}
                type="button"
              />
            </div>
          </div>
        </div>
      </form>
    );
  }
}

HintsCSAddForm.propTypes = {
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  onActionFailed: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
    formatDate: PropTypes.func.isRequired,
  }).isRequired,
  concurrentStudies: PropTypes.arrayOf(PropTypes.any).isRequired,
  onAdd: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
};

const mapDispatchToProps = dispatch => ({
  onActionFailed: (graphqlResponse) => {
    dispatchGraphqlErrors(dispatch, graphqlResponse);
  },
});

export default withRouter(
  connect(
    null,
    mapDispatchToProps,
  )(
    reduxForm({
      form: 'addCSRespondent',
    })(injectIntl(HintsCSAddForm)),
  ),
);
